import { isEmpty } from 'lodash'

const moment = require('moment')
const { dateFields } = require('../form')
const dateFormat = 'YYYY-MM-DD'
const dateTimeFormat = 'YYYY-MM-DD HH:mm'
import { CAMERAS_ID_RE, ERROR_VALUE_RE, HTML_RE, HTML_TAG_RE } from './regular-expressions'

export default {
  methods: {
    /**
     *
     * @param label
     * @return {*}
     */
    removeTags(label) {
      // kiszedi a html tageket a stringbol
      return label.replace(HTML_TAG_RE, '')
    },
    getDisplayedErrorMessage(msg) {
      const { text, params } = this.createMessageObject(msg)
      if (isEmpty(params)) {
        return this.$i18n.t(text)
      } else {
        if (params.hasOwnProperty('label')) {
          params.label = this.$i18n.t(params.label)
        }
        return this.$i18n.interpolate(this.$i18n.t(text), params)
      }
    },
    /**
     *
     * @param msg
     * @param name
     * @param label
     * @param fieldType
     * @return {*}
     */
    createMessageObject({ msg = 'unhandled_error_message', name = '', label = '', fieldType }) {
      if (Array.isArray(label)) {
        label = label[0] || ''
      }

      const zero = (nr) => `0${nr}`.substr(-2)
      if (CAMERAS_ID_RE.test(msg)) msg = msg.replace(CAMERAS_ID_RE, '${label}').replace(`${this.$storeNamespace}-`, '')
      msg = msg.includes(name) ? msg.replace(name, '${label}') : msg.replace(/field\d+/g, '${label}') // @regex lecsereli a fieldX reszt a mezo cimkejet helyettesito placeholderre
      let number = msg.match(ERROR_VALUE_RE)
      label = label.match(HTML_RE) ? this.removeTags(label) : label

      if (number) {
        number = number[0].trim()
        msg = msg.replace(number, '${number}')
        if (dateFields.includes(fieldType)) {
          switch (fieldType) {
            case 'time': {
              number = `${zero(new Date(Number(number)).getHours())}:${zero(new Date(Number(number)).getHours())}`
              break
            }
            case 'date': {
              number = moment(Number(number)).format(dateFormat)
              break
            }
            case 'datetime':
            case 'datetime-local': {
              number = moment(Number(number)).format(dateTimeFormat)
              break
            }
          }
        }
        return { text: msg, params: { label, number } }
      } else {
        return { text: msg, params: { label } }
      }
    },
  },
}
